import { MagnifyingGlass, MapTrifold } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import SiteNav from "@/components/SiteNav";
import { IDX_EMBED_HTML } from "@/lib/constants";

export default function MlsSearch() {
  return (
    <div className="bg-background min-h-screen">
      <SiteNav />
      <div className="max-w-7xl mx-auto px-6 pt-28 pb-16">
        <div className="mb-8">
          <p className="text-brand text-xs uppercase tracking-[0.3em] mb-3">Powered by OneKey® MLS</p>
          <h1 className="text-4xl md:text-5xl text-white">Search the entire MLS</h1>
          <p className="text-white/50 mt-2 max-w-2xl">
            Browse every active listing across New York in real time. See something you like?
            Reach out and Lamar will get you in for a showing.
          </p>
        </div>

        {IDX_EMBED_HTML ? (
          <div
            data-testid="idx-embed"
            className="rounded-sm overflow-hidden border border-white/10 bg-white h-[85vh] min-h-[700px]"
            // OneKey IDX framing embed (iframe/script provided by OneKey)
            dangerouslySetInnerHTML={{ __html: IDX_EMBED_HTML }}
          />
        ) : (
          <div data-testid="idx-placeholder" className="bg-[#101116] border border-white/5 rounded-sm py-20 px-6 text-center">
            <MapTrifold size={48} weight="duotone" className="mx-auto text-brand/50 mb-5" />
            <h2 className="text-2xl text-white mb-3">Live MLS search — almost ready</h2>
            <p className="text-white/50 max-w-xl mx-auto leading-relaxed">
              The live OneKey® MLS search will appear here once the IDX feed is connected.
              In the meantime, browse Lamar's curated listings below.
            </p>
            <Link
              to="/listings"
              data-testid="mls-fallback-listings"
              className="inline-flex items-center gap-2 mt-7 px-7 py-3.5 rounded-sm bg-brand text-black text-sm uppercase tracking-[0.1em] font-medium hover:bg-brand-hover transition-colors"
            >
              <MagnifyingGlass size={16} weight="bold" /> Browse listings
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
